










import Loader from '@/components/Loader.vue';
import Translation from '@/components/i18n/Translation.vue';
import Button from '@/components/Button.vue';
import TabBar from '@/components/TabBar.vue';
import NavBar from '@/components/NavBar.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation, namespace } from 'vuex-class';
import i18next from 'i18next';
import Booking from '@/types/taxcard/Booking';
import CheckoutApi from '@/app/api/CheckoutApi';
import BookingPriceProjection from '@/types/projections/BookingPriceProjection';
import { GuestTypesEnum } from '@/types/taxcard/GuestType';

const CheckoutModule = namespace('checkout');
const BookingModule = namespace('booking');

@Component({
  components: {
    NavBar,
    TabBar,
    Button,
    Translation,
    Loader,
  },
})
export default class CheckoutPaymentVerifyView extends Vue {
  public get checkoutInfo() {
    return this.$route.query.checkoutInfo || null;
  }

  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  @Getter
  public loggedInUser!: any;

  @BookingModule.Getter
  public currentOrderId!: any;

  @Mutation
  public changeLocation!: any;

  @Action
  public loadCommuneData!: any;

  @Action
  public saveRegistrationForm!: any;

  @BookingModule.Mutation
  private setCurrentBooking!: any;

  @BookingModule.Getter
  private currentBooking!: Booking;

  @BookingModule.Getter
  public currentPriceProjection!: BookingPriceProjection | null;

  @BookingModule.Mutation
  private setCurrentPriceProjection!: any;

  @BookingModule.Mutation
  private setCurrentOrderId!: any;

  public async mounted() {
    const { id, resourcePath, orderId, paymentMethod, RETURNMAC, hostedCheckoutId } = this.$route.query;
    console.log(`ResourcePath: ${resourcePath} id: ${id} orderId: ${orderId} paymentMethod: ${paymentMethod}`)

    this.$trackEvent('checkout', 'payment-verification', 'entered');

    this.changeLocation(this.currentBooking.communeId);
    this.loadCommuneData();

    const calcId = paymentMethod != 'PAYONE' ? id : hostedCheckoutId;
    const calcResourcePath = paymentMethod != 'PAYONE' ? resourcePath : RETURNMAC;

    try {
      const verifyResponse: any = await CheckoutApi.verifyPayment(
        calcId as string,
        calcResourcePath as string,
        orderId as string,
        paymentMethod as string
      );
      if (verifyResponse === 'Duplicated Transaction') {
        this.$router.push({ name: 'transactionOverview' });
        return;
      }
      const revenue = (this.currentPriceProjection && this.currentPriceProjection.price) || 0;
      this.$trackGoal(1, revenue);
      this.$trackEvent('checkout', 'payment-verification', 'success');
      this.successOverlay();
      if (this.currentBookingIsRegistrationFormCandidate()) {
        await this.sendEmptyRegistrationForm();
      }
    } catch (e) {
      this.$trackEvent('checkout', 'payment-verification', 'error');
      console.log('Failed to verify payment', e);
      this.errorOverlay();
    } finally {
      window.history.pushState({}, document.title, '/');
    }
  }

  async sendEmptyRegistrationForm() {
    try {
      await this.saveRegistrationForm({
        signature: null,
        passportNumber: '',
        orderId: this.currentOrderId,
      });
    } catch (e) {
      console.log('Could not save registration form!');
    }
  }

  private resetBookingData(): void {
    this.setCurrentBooking(null);
    this.setCurrentPriceProjection(null);
    this.setCurrentOrderId(null);
  }

  private successOverlay(): void {
    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        submit: () => {
          if (!this.currentBookingIsRegistrationFormCandidate()) {
            this.resetBookingData();
            this.$router.push({ name: 'transactionOverview', params: { purchaseSuccess: 'true' } });
            return;
          }
          this.$router.push({ name: 'bookingRegistrationForm' });
        },
        title: i18next.t('checkout.payment.verify.dialog.success.title'),
        message: i18next.t('checkout.payment.verify.dialog.success.body'),
      },
    });
  }

  private errorOverlay(): void {
    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        submit: () => {
          // this.resetBookingData();
          this.$router.push({ name: 'checkout' });
        },
        title: i18next.t('checkout.payment.verify.dialog.failed.title'),
        message: i18next.t('checkout.payment.verify.dialog.failed.body'),
      },
    });
  }

  private currentBookingIsRegistrationFormCandidate(): boolean {
    const booking = this.currentBooking;
    if (!booking) {
      return false;
    }

    // return booking.bIObjects.some(t => t.bIObjectData.guestType === GuestTypesEnum.overnight); //Registration for all
    return booking.bIObjects.some(t => t.bIObjectData.guestType === GuestTypesEnum.overnight && t.bIObjectData.nationality !== 'DE'); //Registration form only for foreigners
  }
}
